import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://epersonel.com.tr";
const OG_IMAGE_PATH = process.env.REACT_APP_OG_IMAGE_PATH || "/og-image.png?v=3";

function resolveOgImage(image) {
  if (image) return image;
  // Prefer absolute URL derived from the current origin so scrapers/WhatsApp
  // don't have to resolve relative paths.
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return `${window.location.origin}${OG_IMAGE_PATH}`;
  }
  return `${SITE_URL}${OG_IMAGE_PATH}`;
}

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO helper — updates title, description, canonical URL and Open Graph tags.
 * @param {{ title: string, description: string, ogTitle?: string, ogDescription?: string, image?: string }} opts
 */
export default function useSeo(opts) {
  const { title, description, ogTitle, ogDescription, image } = opts;
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) document.title = title;
    const canonical = `${SITE_URL}${pathname}`;
    const ogImage = resolveOgImage(image);
    upsertMeta("name", "description", description);
    upsertLink("canonical", canonical);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:locale", "tr_TR");
    upsertMeta("property", "og:site_name", "Epersonel");
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:title", ogTitle || title);
    upsertMeta("property", "og:description", ogDescription || description);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:image:secure_url", ogImage);
    upsertMeta("property", "og:image:width", "1200");
    upsertMeta("property", "og:image:height", "630");
    upsertMeta("property", "og:image:type", "image/png");
    upsertMeta("property", "og:image:alt", ogTitle || title || "Epersonel");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", ogTitle || title);
    upsertMeta("name", "twitter:description", ogDescription || description);
    upsertMeta("name", "twitter:image", ogImage);
  }, [title, description, ogTitle, ogDescription, image, pathname]);
}
